import React from 'react';
export function Footer() {
  return <footer className="bg-ink py-12 text-cream/70" data-id="element-31" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-32" data-mp="3gezev8fo7z39">
        <p className="font-display text-xl font-black text-cream" data-id="element-33" data-mp="3ggka709t7m26">Método Maestro Amigurumi</p>
        <p className="mt-3 text-sm leading-relaxed" data-id="element-34" data-mp="32pp764lzrz6i">
          Guía digital de crochet paso a paso. Acceso inmediato tras la compra. Los resultados
          dependen de la práctica de cada tejedora.
        </p>
        <p className="mt-6 text-xs" data-id="element-35" data-mp="3ucxmluzhkx9s">
          © {new Date().getFullYear()} Método Maestro Amigurumi · Hecho con lana y paciencia en
          Argentina
        </p>
      </div>
    </footer>;
}